module.exports = __webpack_public_path__ + "static/media/fuel-system-monitor.156afdc0.svg";